export const TYPE_LIST = [
	{
		value: "VOUCHER",
		name: "Voucher",
	},
	{
		value: "ORDER_ID",
		name: "Order ID",
	},
];

export const MONTH_LIST = [
	{ value: "JAN", name: "January" },
	{ value: "FEB", name: "February" },
	{ value: "MAR", name: "March" },
	{ value: "APR", name: "April" },
	{ value: "MAY", name: "May" },
	{ value: "JUN", name: "June" },
	{ value: "JUL", name: "July" },
	{ value: "AUG", name: "August" },
	{ value: "SEP", name: "September" },
	{ value: "OCT", name: "October" },
	{ value: "NOV", name: "November" },
	{ value: "DEC", name: "December" },
];
